module.exports = __webpack_public_path__ + "assets/img/lbg.b8ecbc16.jpg";